import { useCallback } from "react";
import { useDiscountsContext } from "../Discount.Context";

export const useUpdateDiscountItem = () => {
    const { dispatch } = useDiscountsContext();
    
    const updateDiscountItem = useCallback((fieldKey, value) => {
        dispatch({ type: "UPDATE_DISCOUNT_ITEM", payload: {fieldKey, value} });
    }, [dispatch]);
    
    return updateDiscountItem;
}